import { Component } from '@angular/core';
import { TableColumn } from 'src/app/components/table';
import { BfluGlamgirlSignupReportService } from './bflu-glamgirl-signup-report.service';

@Component({
  selector: 'app-reprocessamentos',
  templateUrl: './reprocessamentos.component.html'
})
export class ReprocessamentosComponent {
  mappedColumns: Array<TableColumn> = [
    new TableColumn('Situação', 'situacao', true, 'text', undefined, undefined, true, 'equals'),
    new TableColumn('Motivo', 'motivo', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Nome', 'nome', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Email', 'email', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Phone', 'phone', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('PersonId', 'personId', true, 'number', '/users/person/', 'personId'),
    new TableColumn(
      'SubscriberId',
      'subscriberId',
      true,
      'number',
      '/users/subscribers/',
      'subscriberId'
    ),
    new TableColumn('Name Type', 'nameType', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Data de Criação', 'dateCreated', true, 'date', undefined, undefined, true, 'between'),
    new TableColumn('TID', 'tid', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Total', 'amount', true, 'currency', undefined, undefined, true, 'gte'),
    new TableColumn(
      'Mensagem de Autorização',
      'authorizationMessage',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn(
      'Status da Transação',
      'transactionStatusId',
      true,
      'number',
      undefined,
      undefined,
      true,
      'gte'
    ),
    new TableColumn(
      'Nome da Assinatura',
      'subscriptionName',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn('Plano', 'plano', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn(
      'CreditCardPaymentId',
      'creditCardPaymentId',
      true,
      'number',
      undefined,
      undefined,
      true,
      'gte'
    )
  ];

  completedColumns: Array<TableColumn> = [
    new TableColumn('Situação', 'situacao', true, 'text', undefined, undefined, true, 'equals'),
    new TableColumn('Motivo', 'motivo', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Nome', 'nome', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Email', 'email', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Phone', 'phone', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('PersonId', 'personId', true, 'number', '/users/person/', 'personId'),
    new TableColumn(
      'SubscriberId',
      'subscriberId',
      true,
      'number',
      '/users/subscribers/',
      'subscriberId'
    ),
    new TableColumn('Name Type', 'nameType', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Data de Criação', 'dateCreated', true, 'date', undefined, undefined, true, 'between'),
    new TableColumn(
      'Data da captura',
      'dateAuthorized',
      true,
      'date',
      undefined,
      undefined,
      true,
      'between'
    ),
    new TableColumn('TID', 'tid', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Total', 'amount', true, 'currency', undefined, undefined, true, 'gte'),
    new TableColumn(
      'Mensagem de Autorização',
      'authorizationMessage',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn(
      'Status da Transação',
      'transactionStatusId',
      true,
      'number',
      undefined,
      undefined,
      true,
      'gte'
    ),
    new TableColumn(
      'Nome da Assinatura',
      'subscriptionName',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn('Plano', 'plano', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn(
      'CreditCardPaymentId',
      'creditCardPaymentId',
      true,
      'number',
      undefined,
      undefined,
      true,
      'gte'
    )
  ];

  reportColumns: Array<TableColumn> = [
    new TableColumn('Situação', 'situacao', true, 'text', undefined, undefined, true, 'equals'),
    new TableColumn('Motivo', 'motivo', true, 'text', undefined, undefined, true, 'contains'),
    new TableColumn('Data', 'dateCreated', true, 'date', undefined, undefined, true, 'between'),
    new TableColumn(
      'E-mail da BFLU',
      'influencerEmail',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn('Id da BFLU', 'influencerUserId', true, 'number'),
    new TableColumn(
      'E-mail da glamgirl',
      'customerEmail',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn('Comentário', 'comment', true, 'text', undefined, undefined, true, 'contains')
  ];

  constructor(public reportService: BfluGlamgirlSignupReportService) {}
}
